module.exports = __webpack_public_path__ + "img/enlarge.637a19a.png";